import { useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'
import Swal from 'sweetalert2'

const FlashStyles = createGlobalStyle`
  // Swal custom
  // General
  .swal2-close:focus {
    box-shadow: none;
  }
  .timepage-alert-container.swal2-backdrop-show {
    background: rgba(0, 0, 0, .4);
  }
  .timepage-alert-popup.swal2-show {
    width: unset;
    width: 70%;
    height: 100%;
    margin: 4rem auto;
  }
  .timepage-alert-title {
    color: #333333;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 4rem;
  }
  // SideAlerts
  .side-alert-container.swal2-container.swal2-backdrop-show {
    background: transparent;
  }
  .side-alert-popup {
    width: auto;
    background-color: #d0edd5;
    padding: 1.2rem 2.4rem;
  }
  .side-alert-error {
    width: auto;
    background-color: #F39274;
    padding: 1.2rem 2.4rem;
  }
  .side-alert-header {
    padding: 0;
  }
  .side-alert-title {
    font-size: 1.2rem;
    color: #333333;
    font-weight: 600;
    line-height: 1.2em;
    margin: 0;
  }
  .swal2-show {
    animation: swal2-show ease 0.4s;
  }
  @keyframes swal2-show {
    0% {
      transform: scale(0.8);
    }
    25% {
      transform: scale(0.9);
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  // Swal chatbot custom styles
  .swal-chatbot-container {
    bottom: 4rem !important;
    border-radius: 1rem !important;
  }
  .swal-chatbot-close {
    position: absolute !important;
    font-size: 1.5rem !important;
    right: 0.5rem !important;
    top: 0.5rem !important;
    color: #1882ff !important;
  }
  .swal-chatbot-content {
    padding: 0 !important;
    color: #333333 !important;
  }
`

export const displayErrorAlert = (error) => {
  return Swal.fire({
    position: 'top-end',
    title: error || "Une erreur s'est produite",
    showConfirmButton: false,
    customClass: {
      container: 'side-alert-container',
      popup: 'side-alert-error',
      header: 'side-alert-header',
      title: 'side-alert-title'
    },
    timer: 3000
  })
}

/**
 * React component that handles flash alerts.
 * Includes its own styles to ensure they are available when the alert is displayed.
 */
const Flash = () => {
  const [hasDisplayed, setHasDisplayed] = useState(false)

  useEffect(() => {
    if (hasDisplayed) return

    // Check for flash alerts from data-attributes (Rails redirections)
    const dataset = document.body.dataset
    if (dataset.flashAlert) {
      displayErrorAlert(dataset.flashAlert)
      delete document.body.dataset.flashAlert
      setHasDisplayed(true)
      return
    }

    // Check for flash alerts from sessionStorage (API redirections)
    const alertMessage = sessionStorage.getItem('flash_error')
    if (alertMessage) {
      displayErrorAlert(alertMessage)
      sessionStorage.removeItem('flash_error')
      setHasDisplayed(true)
    }
  }, [hasDisplayed])

  return <FlashStyles />
}

export default Flash
